'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import classNames from 'classnames';
export default function UIMultiColumn(props) {
  const {
    children,
    className,
    flush
  } = props,
        other = _objectWithoutPropertiesLoose(props, ["children", "className", "flush"]);

  return /*#__PURE__*/_jsx("div", Object.assign({}, other, {
    className: classNames('private-multicolumn', className, flush && 'private-multicolumn--flush'),
    children: children
  }));
}
UIMultiColumn.displayName = 'UIMultiColumn';
UIMultiColumn.propTypes = {
  children: PropTypes.node,
  flush: PropTypes.bool.isRequired
};
UIMultiColumn.defaultProps = {
  flush: false
};